import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from './helpers/auth.guard';

// Layouts
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';
import { EmptyLayoutComponent } from './layout/empty-layout/empty-layout.component';
import { SidebarLayoutComponent } from './layout/sidebar-layout/sidebar-layout.component';

import { MyProfileComponent } from './partial/my-profile/my-profile.component';
import { CalenderViewHeaderComponent } from './partial/calender-view/calender-view-header/calender-view-header.component';
import { PdfViewerComponent } from './partial/pdf-viewer/pdf-viewer.component';

const routes: Routes = [
  {
    path: '',
    component: EmptyLayoutComponent,
    children: [
      { path: '', loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule) },
    ]
  },
  {
    path: 'admin',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    data: { breadcrumb: 'Home' },
    children: [
      { path: '', component: MyProfileComponent, data: { breadcrumb: 'My Profile' } },
      { path: 'myprofile', component: MyProfileComponent, data: { breadcrumb: 'My Profile' } },
      { path: 'userdetails/:userId', component: MyProfileComponent, data: { breadcrumb: 'User details' } },

      {
        path: 'dashboard', data: { breadcrumb: 'Dashboard' },
        loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'managegroups', data: { breadcrumb: 'Manage groups' },
        loadChildren: () => import('./modules/managegroups/managegroups.module').then(m => m.ManagegroupsModule)
      },
      {
        path: 'managtracks', data: { breadcrumb: 'Manage Entities' },
        loadChildren: () => import('./modules/manageentity/manageentity.module').then(m => m.ManageentityModule)
      },
      {
        path: 'manageusers', data: { breadcrumb: 'Manage Users' },
        loadChildren: () => import('./modules/manageusers/manageusers.module').then(m => m.ManageusersModule)
      },
      {
        path: 'tasks', data: { breadcrumb: 'Tasks' },
        loadChildren: () => import('./modules/tasks/tasks.module').then(m => m.TasksModule)
      },
      {
        path: 'meetings', data: { breadcrumb: 'Meetings' },
        loadChildren: () => import('./modules/meetings/meetings.module').then(m => m.MeetingsModule)
      },
      {
        path: 'packages', data: { breadcrumb: 'Packages' },
        loadChildren: () => import('./modules/packages/packages.module').then(m => m.PackagesModule)
      },
      {
        path: 'subscribers', data: { breadcrumb: 'Subscribers' }
        , loadChildren: () => import('./modules/subscribers/subscribers.module').then(m => m.SubscribersModule)
      },
      { path: 'calenderview', component: CalenderViewHeaderComponent, data: { breadcrumb: '' } },
      {
        path: 'payment', data: { breadcrumb: 'Payment Method' },
        loadChildren: () => import('./modules/payment-method/payment-method.module').then(m => m.PaymentMethodModule)
      },
      {
        path: 'voting', data: { breadcrumb: 'Voting' },
        loadChildren: () => import('./modules/voting/voting.module').then(m => m.VotingModule)
      },
      {
        path: 'contribution', data: { breadcrumb: 'myContributions' },
        loadChildren: () => import('./modules/contribution/contribution.module').then(m => m.ContributionModule)
      },
      {
        path: 'badgesmanagement', data: { breadcrumb: 'badgesManagement' },
        loadChildren: () => import('./modules/badges-management/badges-management.module').then(m => m.BadgesManagementModule)
      },
      {
        path: 'mybadges', data: { breadcrumb: 'myBadges' },
        loadChildren: () => import('./modules/user-badges/user-badges.module').then(m => m.UserBadgesModule)
      },
      {
        path: 'ambassadorspromotion', data: { breadcrumb: 'ambassadorsPromotion' },
        loadChildren: () => import('./modules/ambassadors-promotion/ambassador-promotion..module').then(m => m.AmbassadorsPromotionModule)
      },
      {
        path: 'reports', data: { breadcrumb: 'reports' },
        loadChildren: () => import('./modules/reports/reports.module').then(m => m.ReportsModule)
      },
      {
        path: 'cpadashboard', data: { breadcrumb: 'Dashboard' },
        loadChildren: () => import('./modules/cpa-dashboard/cpa-dashboard.module').then(m => m.cpaDashboardModule)
      },

      // { path: 'votingprint', loadChildren: () => import('./modules/votingprint/votingprint.module').then(m => m.VotingprintModule) },
      { path: 'signatureDocs', loadChildren: () => import('./modules/signature-docs/signature-docs.module').then(m => m.SignatureDocsModule) },
    ]
  },
  {
    path: 'admin',
    component: SidebarLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      // { path: 'messages', component: MessagesComponent, data: { breadcrumb: 'Messages' } }
      {
        path: 'messages', data: { breadcrumb: 'Messages' },
        loadChildren: () => import('./modules/messages/messages.module').then(m => m.MessagesModule)
      },
    ]
  },
  {
    path: 'admin',
    component: EmptyLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      // { path: 'livemeeting/:meetingId', component: LiveMeetingComponent, data: { breadcrumb: 'Live Meeting' } },
      {
        path: 'livemeeting', data: { breadcrumb: 'Live Meeting' },
        loadChildren: () => import('./modules/live-meeting/live-meeting.module').then(m => m.LiveMeetingModule)
      },
      {
        path: 'multilivemeeting',
        loadChildren: () => import('./modules/multi-live-meeting/multi-live-meeting.module').then(m => m.MultiLiveMeetingModule)
      },
      // {
      //   path: 'multijistiusers',
      //   loadChildren: () => import('./multi-jisti-users/multi-jisti-users.module').then(m => m.MultiJistiUsersModule)
      // },
      // { path: 'slidesViewer', loadChildren: () => import('./modules/slides-viewer/slides-viewer.module').then(m => m.SlidesViewerModule) },
      { path: 'dicom-viewer', loadChildren: () => import('./modules/dicom-viewer/dicom-viewer.module').then(m => m.StudyViewerModule) },
      { path: 'pdf/:documentId/:relatedToId/:relatedParentId', component: PdfViewerComponent, data: { breadcrumb: 'PDF Viewer' } },
      { path: 'pdf/:documentId/:relatedToId', component: PdfViewerComponent, data: { breadcrumb: 'PDF Viewer' } },
    ]
  },
  // otherwise redirect to home
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled', onSameUrlNavigation: 'reload'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
